var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoldoutIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "136px",
    height: "136px",
    viewBox: "0 10 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#8B3C7E",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#8B3C7E;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}")), /*#__PURE__*/React.createElement("g", {
    id: "sold-out"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 27,
    width: 51,
    x: 5,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 6,
    rx: 1.3178,
    width: 4,
    x: 34,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 6,
    rx: 1.3178,
    width: 4,
    x: 27,
    y: 28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38,28v4.6822A1.3178,1.3178,0,0,1,36.6822,34H35.3178A1.3178,1.3178,0,0,1,34,32.6822V28"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "31 18 27 18 27 21 31 21 31 24 27 24"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 15.5,
    cy: 26.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 28,
    x2: 28,
    y1: 40.2662,
    y2: 61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 33,
    x2: 33,
    y1: 61,
    y2: 40.2974
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 18,
    x2: 13,
    y1: 24,
    y2: 29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13,
    x2: 18,
    y1: 24,
    y2: 29
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "41 18 41 24 44 24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47,18h2.7492A1.2508,1.2508,0,0,1,51,19.2508v3.4985A1.2508,1.2508,0,0,1,49.7492,24H47a0,0,0,0,1,0,0V18A0,0,0,0,1,47,18Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 43,
    x2: 43,
    y1: 34,
    y2: 28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 41,
    x2: 45,
    y1: 28,
    y2: 28
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoldoutIcon);
export default __webpack_public_path__ + "static/media/soldoutIcon.fb7158549af85111e334397e48689abc.svg";
export { ForwardRef as ReactComponent };